import { useEffect, useState } from 'react';

export default function useIntersectionObserver({
  target,
  threshold = 0,
  defaultValue = false,
}: any) {
  const [show, setShow] = useState(defaultValue);

  useEffect(() => {
    if (target) {
      const handleIntersect = (entries: any[]) => {
        entries.forEach((entry: { isIntersecting: any }) => {
          if (entry.isIntersecting) {
            // 目标元素进入视口
            setShow(true);
          } else {
            // 目标元素离开视口
            setShow(false);
          }
        });
      };

      let options = {
        root: null,
        rootMargin: '0px 0px 600px 0px',
        threshold: threshold,
      };

      let observer = new IntersectionObserver(handleIntersect, options);

      observer.observe(target);

      return () => {
        observer.unobserve(target);
        observer.disconnect();
      };
    }
  }, [target]);

  return { show };
}
